<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Multiple select-->
        <div class="box">
          <div class="box-header with-border">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>学校管理</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/teacher/teacherList' }">教师列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="box-body" style="min-height:80%;">
            <div class="search-div">
              <el-input v-model="name" placeholder="姓名" class="input-size-200 input-margin-right" clearable></el-input>
              <el-input v-model="phone" placeholder="手机" class="input-size-200 input-margin-right" clearable></el-input>
              <el-input v-model="schoolNo" placeholder="员工号" class="input-size-200 input-margin-right" clearable></el-input>
<!--              <el-input v-model="account" placeholder="银行账号" class="input-size-200 input-margin-right" clearable></el-input>-->
              <el-input v-model="departmentName" placeholder="学校" v-if="userType == 'ORDINARY'" class="input-size-200 input-margin-right" clearable></el-input>
              <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="search()">搜索</el-button>
              <el-button type="" icon="el-icon-download" class="button-pull-right" style="margin-right: 20px" @click="exportDialogVisible = true;">导出</el-button>
              <el-button type="info" icon="el-icon-upload2" class="button-pull-right" style="margin-right: 20px" @click="excelImportResult = null; dialogExcelVisible = true;">导入</el-button>
              <el-button type="success" icon="el-icon-plus" class="button-pull-right" @click="handleCreate()">新增</el-button>
              <br/>
            </div>
            <el-table
              ref="multipleTable"
              :data="dt.data"
              :stripe="true"
              border
              highlight-current-row
              style="width: 100%"
              :size="dt.size"
              :cell-style="{fontFamily: '宋体', fontSize: '16px'}"
              @sort-change="dt.handleSortChange"
              @selection-change="dt.handleSelectionChange">
<!--              <el-table-column-->
<!--                type="selection"-->
<!--                fixed-->
<!--                width="50px">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                property="id"-->
<!--                label="ID"-->
<!--                fixed-->
<!--                width="80px">-->
<!--              </el-table-column>-->
              <el-table-column
                property="name"
                label="姓名"
                sortable="custom"
                width="120px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="phone"
                label="手机"
                sortable="custom"
                width="120px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="schoolNo"
                label="员工号"
                sortable="custom"
                width="120px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="schoolDeptName"
                label="学校部门"
                sortable="custom"
                width="160px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
<!--              <el-table-column-->
<!--                property="account"-->
<!--                label="银行账号"-->
<!--                sortable="custom"-->
<!--                show-overflow-tooltip>-->
<!--              </el-table-column>-->
              <el-table-column
                property="nature"
                label="人员性质"
                width="100px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="departmentName"
                label="学校名称"
                v-if="userType == 'ORDINARY'"
                sortable="custom"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <!--<el-table-column-->
                <!--property="bannedTime"-->
                <!--:formatter="dateFormat"-->
                <!--label="禁言时间"-->
                <!--width="150px"-->
                <!--sortable="custom"-->
                <!--show-overflow-tooltip>-->
              <!--</el-table-column>-->
<!--              <el-table-column-->
<!--              property="parentPhone"-->
<!--              label="父账户手机"-->
<!--              width="100px"-->
<!--              sortable="custom"-->
<!--              show-overflow-tooltip>-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="type"-->
<!--                label="标签"-->
<!--                width="120">-->
<!--                <template slot-scope="scope">-->
<!--                  <el-tag-->
<!--                    :type="scope.row.type === 'ORDINARY' ? 'primary' : 'success'"-->
<!--                    close-transition>{{scope.row.type=='ORDINARY'?'平台管理员':'学校管理员'}}-->
<!--                  </el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column
                property="updatedUserName"
                label="录入人"
                width="100px"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="createdAt"
                label="创建时间"
                width="110px"
                :formatter="dateFormat"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                property="updatedAt"
                label="修改时间"
                width="110px"
                :formatter="dateFormat"
                class-name="money"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="250px" class-name="money">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.phone != '83878320331'"
                    size="small"
                    @click="handleEdit(scope.$index, scope.row)">编辑
                  </el-button>
                  <el-button
                    v-if="scope.row.phone != '83878320331'"
                    size="small"
                    type="info"
                    @click="handleResetPassword(scope.$index, scope.row)">重置密码
                  </el-button>
                  <el-button
                    v-if="scope.row.phone != '83878320331' && scope.row.status != 'DISABLED'"
                    size="small"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="dt.handleSizeChange"
              @current-change="dt.handleCurrentChange"
              :current-page="dt.currentPage"
              :page-sizes="dt.pageSizes"
              :page-size="dt.pageSize"
              :layout="dt.layout"
              :total="dt.totalElements">
            </el-pagination>
          </div>
        </div>

        <!-- Excel 导入弹出框 -->
        <el-dialog title="Excel 导入" :visible.sync="dialogExcelVisible">
          <el-form>
            <el-col :span="24">
              <el-form-item label="学校" class="is-required" prop="excelDepartmentId" v-if="isAdminUser">
                <el-select v-model="excelDepartmentId" style="width: 100%" autocomplete filterable>
                  <el-option v-for="d in departmentList" :label="d.name" :value="d.id" :key="d.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="Excel 文件" class="is-required" prop="excelFile">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx"
                  :limit="1"
                  :action="this.httpBaseURL() + '/admin/teacher/importExcel?departmentId=' + this.excelDepartmentId"
                  :headers="this.httpHead()"
                  :on-change="this.onImportExcelFileChange"
                  :on-success="handleImportExcelSuccess"
                  :auto-upload="false"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <div slot="tip" class="el-upload__tip">请选择Excel文件</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="导入结果" prop="excelImportResult">
                <div class="el-input" v-html="excelImportResult"
                     style="max-height: 250px; overflow:auto; padding: 1rem; border-radius: 4px; border: 1px solid #909399; line-height: 1.8rem"></div>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="success" @click="onImportExcelSubmit()" :disabled="!(excelDepartmentId && excelFileSelected)">导 入</el-button>
            <el-button @click="dialogExcelVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
        <!-- Excel 导入弹出框 END -->

        <!-- Excel 导出弹出框 -->
        <el-dialog title="Excel 导出" :visible.sync="exportDialogVisible">
          <el-form>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="学校" class="is-required" prop="excelDepartmentId" v-if="isAdminUser">
                  <el-select v-model="excelDepartmentId" style="width: 100%" autocomplete filterable>
                    <el-option v-for="d in departmentList" :label="d.name" :value="d.id" :key="d.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="success" @click="onExportSubmit()" :disabled="!(excelDepartmentId)">下 载</el-button>
            <el-button @click="exportDialogVisible = false">关 闭</el-button>
          </div>
        </el-dialog>
        <!-- Excel 导出弹出框 END -->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
  import {DataTable} from "../../../data-table";

  export default {
    name: 'TeacherList',
    data: function () {
      let userInfo = this.$store.state.userInfo;
      let that = this;
      return {
        userType: userInfo.type,
        departmentId: userInfo.departmentId,
        //  表格设置
        extnedsParms: {},
        dt: DataTable.getInstance(that, '/admin/teacher/findPage', null, null),
        name: '',
        phone: '',
        schoolNo: '',
        account: '',
        departmentName: '', // 学校名称 （平台管理员才使用）
        dialogFormVisible: false,

        loading: null,

        // Excel导入
        departmentList: [],
        excelDepartmentId: userInfo.departmentId,
        excelImportResult: null,
        excelFileSelected: false,
        dialogExcelVisible: false,
        exportDialogVisible: false
      }
    },
    computed: {
      // 是否 平台管理员 在操作
      isAdminUser: function () {
        return this.userType === 'ORDINARY';
      }
    },
    mounted: function () {
      // 清理旧的绑定属性
      this.dt.cleanBindFields();
      // 绑定过滤属性
      this.dt.bindStringField("name", "name");
      this.dt.bindStringField("phone", "phone");
      this.dt.bindStringField("schoolNo", "schoolNo");
      this.dt.bindStringField("account", "account");
      if (this.userType === 'ORDINARY') {
        this.dt.bindStringField("departmentName", "departmentName");
      }
      // 还原之前查询条件到Vue属性
      this.dt.bindFieldToVueProp();
      //  向后台查询数据
      this.dt.queryPageData()

      if (this.isAdminUser) {
        this.axios.get('/admin/department/findAll4Select')
          .then(resp => { // 装载对象
            if (resp.data && resp.data.code === 200) {
              this.departmentList = resp.data.data
            } else {
              this.$router.replace('/user/userList')
              this.$message({
                type: 'error',
                message: "获取部门列表失败"
              })
            }
          }).catch(resp => {
          this.$router.replace('/user/userList')
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        })
      }
    },

    methods: {
      dateFormat: function (row, column) {
        var date = row[column.property];
        if (date === undefined || date === null) {
          return "";
        }
        return this.$moment(date).format("YYYY-MM-DD");
      },
      //  创建新记录
      handleCreate: function () {
        if (this.isAdminUser) { // 平台管理员
          this.$router.push('/teacher/teacherModify')
        } else { //  学校管理员（限制学校id）
          let that = this;
          // console.log(that.departmentId);
          this.$router.push({path: '/teacher/teacherModify', query: {departmentId: that.departmentId}});
        }
      },
      // 编辑记录
      handleEdit: function (index, row) {
        if (this.isAdminUser) { // 平台管理员
          this.$router.push({path: '/teacher/teacherModify', query: {id: row.id}});
        } else { //  学校管理员（限制学校id）
          let that = this;
          this.$router.push({path: '/teacher/teacherModify', query: {id: row.id, departmentId: that.departmentId}});
        }
      },
      // 搜索
      search: function () {
        // 更新最新的查询条件
        this.dt.bindFieldToFilter();
        this.dt.queryPageData()
      },
      // Excel 选择文件改变
      onImportExcelFileChange: function (file, fileList) {
        this.excelFileSelected = (fileList && fileList.length === 1);
      },
      // Excel 上传提交
      onImportExcelSubmit: function () {
        this.loading = this.$loading({
          lock: true,
          text: '正在上传中....',
          spinner: 'el-icon-loading-new',
          background: 'rgba(0, 0, 0, 0.2)'
        });
        this.$refs.upload.submit();
      },
      // Excel 上传成功
      handleImportExcelSuccess: function (response, file, fileList) {
        this.$refs.upload.clearFiles();
        this.excelFileSelected = false;
        this.loading.close();
        if (response && response.code === 200) {
          this.excelImportResult = response.data;
          this.$message({
            type: 'success',
            message: '上传完成，请查看 导入结果'
          })
          this.search();
        } else {
          this.$message({
            type: 'error',
            message: response.message
          })
          this.excelImportResult = response.message;
        }
      },
      // 重置密码
      handleResetPassword: function (index, row) {
        this.$confirm('此操作将重置该用户密码, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '执行中...'
              setTimeout(() => {
                this.axios.post('/admin/user/resetPassword', [], {params: {id: row.id}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done()
                      this.search();
                      this.$message({
                        type: 'success',
                        message: '处理成功'
                      })
                    } else {
                      done()
                      this.$message({
                        type: 'error',
                        message: '处理失敗'
                      })
                    }
                  }).catch(resp => {
                  done()
                  this.$message({
                    type: 'error',
                    message: '处理失敗'
                  })
                })
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 1000)
            } else {
              done()
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      },
      // 删除
      handleDelete: function (index, row) {
        this.$confirm('此操作将删除该教师账号（他无法再登录微信小程序）, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '执行中...'
              setTimeout(() => {
                this.axios.post('/admin/teacher/deleteTeacher', [], {params: {id: row.id}})
                  .then(resp => { // 保存成功跳回列表页面
                    if (resp.data.code === 200) {
                      done()
                      this.dt.queryPageData()
                      this.$message({
                        type: 'success',
                        message: '刪除成功'
                      })
                    } else {
                      done()
                      this.$message({
                        type: 'error',
                        message: '刪除失敗'
                      })
                    }
                  }).catch(resp => {
                  done()
                  this.$message({
                    type: 'error',
                    message: '刪除失敗'
                  })
                })
                setTimeout(() => {
                  instance.confirmButtonLoading = false
                }, 300)
              }, 1000)
            } else {
              done()
            }
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 导出提交
      onExportSubmit: function () {
        let that = this;
        this.loading = this.$loading({
          lock: true,
          text: '正在下载中....',
          spinner: 'el-icon-loading-new',
          background: 'rgba(0, 0, 0, 0.2)'
        });
        this.axios.post('/admin/teacher/exportExcel', [],
          {params: {departmentId: that.excelDepartmentId}, responseType: 'blob'})
          .then(resp => { // 装载对象
            if (resp.data.type === "application/json") { // 后台处理过程异常
              const reader = new FileReader()
              reader.onload = function (event) {
                const message = JSON.parse(reader.result).message
                that.$message({
                  type: 'error',
                  message: "请求服务器出错 " + message
                })
              }
              reader.readAsText(resp.data)
            } else {
              let blob = new Blob([resp.data]);
              let fileName = "教师列表" + resp.headers['content-disposition'].split('filename=').pop();
              if ('msSaveOrOpenBlob' in navigator) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href);
                document.body.removeChild(elink);
              }
            }
          }).catch(resp => {
          // console.log(resp);
          this.$message({
            type: 'error',
            message: "请求服务器出错"
          })
        }).finally(() => {
          this.loading.close();
        });
      }
    }
  }
</script>
<style type="scss">
.money {
  font-family: '宋体';
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// TeacherList.vue?c0148022